export function LeaveStatusBadge({ status }) {
  const map = {
    Approved: "bg-[var(--color-success)]/12 text-[var(--color-success)]",
    Pending: "bg-[var(--color-warning)]/12 text-[var(--color-warning)]",
    Rejected: "bg-[var(--color-error)]/12 text-[var(--color-error)]",
    Withdrawn: "bg-[var(--color-text-secondary)]/12 text-[var(--color-text-secondary)]",
    Revoked: "bg-[var(--color-text-secondary)]/12 text-[var(--color-text-secondary)]",
    Cancelled: "bg-[var(--color-text-secondary)]/12 text-[var(--color-text-secondary)]",
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold whitespace-nowrap ${map[status] || "bg-[var(--color-text-secondary)]/12 text-[var(--color-text-secondary)]"}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}
